<template>
  <v-container fluid class="px-1 py-1">
    <CommonTable
        title="CoreChangeLogList"
        :embedded="embedded"
        :height="height"
        :dto-list-query="dtoListQuery"
        :dto-detail-query="dtoDetailQuery"
        :dto-action-command="dtoActionCommand"
        :store-name="storeName"
        :detail-store-name="detailStoreName"
        detailComponentPass="/CoreChangeLog/CoreChangeLogDetail"
        :parent-component="$options.name"
        @embedded_close="$emit('embedded_close')"
    >
    </CommonTable>
  </v-container>
</template>

<script>
import {useAggregateStore} from '@/store/CommonStore/baseAggregateStore'
import {useTableStore} from "@/components/Common/CommonTable";
import CommonTable from "@/components/Common/CommonTable";
import CoreChangeLogDetail from "@/components/CoreChangeLog/CoreChangeLogDetail";

export default {
  name: "CoreChangeLogTable",

  props: {
    embedded: {default: false},
    height: {default: null},
    storeName: {type: [String], default: 'CoreChangeLogTable'},
    dtoDetailQuery: {default: 'ChangeLogDetailQueryDTO'},
    detailStoreName: {default: 'ChangeLogDetail'},
    dtoListQuery: {type: [String], default: 'ChangeLogListQueryDTO'},
    dtoActionCommand: {type: [String], default: 'ChangeLogActionCommandDTO'},
    dtoSaveCommand: {type: [String], default: 'ChangeLogSaveCommandDTO'},
    mainValidator: {type: [Boolean], default: false},
  },

  components: {
    CommonTable,
    CoreChangeLogDetail,
  },

  methods: {
  },


  mounted() {
    this.storeTable = useTableStore(this.storeName)()
    this.storeTable.headers = [
      {text: 'E', value: 'edit', sortable: false, filterable: true, divider: true, width: 30},
      // {text: 'uid', value: 'uid', sortable: true, filterable: true, divider: true, width: 300},
      {text: 'created_on', value: 'created_on', sortable: true, filterable: true, divider: true, type:'datetime'},
      // {text: 'edited_on', value: 'edited_on', sortable: true, filterable: true, divider: true, type:'datetime'},
      {text: 'object_uid', value: 'object_uid', sortable: true, filterable: true, divider: true, width: 300},
      {text: 'object_type', value: 'object_type', sortable: true, filterable: true, divider: true, width: 100},
      {text: 'object_hash', value: 'object_hash', sortable: true, filterable: true, divider: true, width: 100},
      // {text: 'object', value: 'object', sortable: true, filterable: true, divider: true, width: 300},
      {text: 'edited_by', value: 'edited_by_uid', sortable: true, filterable: true, divider: true},
      {text: 'created_by', value: 'created_by_uid', sortable: true, filterable: true, divider: true},
      {text: 'object_created_on', value: 'object_created_on', sortable: true, filterable: true, divider: true, type: 'datetime'},
      {text: 'object_edited_on', value: 'object_edited_on', sortable: true, filterable: true, divider: true, type: 'datetime'},
      {text: '', value: 'is_saved', sortable: false, filterable: true, divider: true, width: 30},
    ]
    this.storeAggregate = useAggregateStore()
    if (!!this.storeTable) {
      this.storeTable.dtoDetailQuery = this.dtoDetailQuery
      this.storeTable.dtoListQuery = this.dtoListQuery
      this.storeTable.dtoActionCommand = this.dtoActionCommand
      this.storeTable.dtoSaveCommand = this.dtoSaveCommand
      this.storeTable.options.sortBy = ['created_on']
    }
  },

  data() {
    return {
      storeTable: null,
    }
  },
}
</script>

<style scoped>

</style>